import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';

import { DeviceFirestoreResponse, DevicesDataResponse } from '../../types';
import { parseFirestoreTimestamp } from '../../utils';
import { fetchPaginatedCollection } from '../utils';

const COLLECTION_PATH = 'pods';

export const useGetDevicesFromFirestore = (
  page: number,
  pageSize: number,
  options?: UseQueryOptions<DevicesDataResponse, FirebaseError, DevicesDataResponse>,
): UseQueryResult<DevicesDataResponse, FirebaseError> => useQuery<DevicesDataResponse,
    FirebaseError, DevicesDataResponse>({
      queryKey: [COLLECTION_PATH, page, pageSize] as const,
      queryFn: async () : Promise<DevicesDataResponse> => {
        const { data, totalPages } = await fetchPaginatedCollection<DeviceFirestoreResponse>(
          COLLECTION_PATH,
          page,
          pageSize,
          'createdAt',
        );
        const mappedData = data.map((item) => ({
          id: item.id,
          createdAt: parseFirestoreTimestamp(item.createdAt)?.date,
          name: item.name,
          serialNumber: item.serial_id,
          color: item.model.color,
          size: item.model.size,
          translationStatus: item.translationStatus,
        }));
        return { data: mappedData, totalPages };
      },
      retry: 0,
      ...options,
    });
